import React, { Suspense, lazy, createContext } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import axios from "axios";
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import LoadingOverlay from "react-loading-overlay";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Alert,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { FaTimes, FaSpinner } from "react-icons/fa";
import Widget from "components/Widget/index";
import MaterialTable from "material-table";
import { tableIcons } from "../../../constants/Icons";
import SweetAlert from "react-bootstrap-sweetalert";
import { regStatus, userSignOut } from "actions/Auth";
import html2canvas from "html2canvas";
import GenericPdfDownloader from "./downloadPDF";
import { Slide, Fade } from "react-reveal"; // Use react-reveal for animations
import TranscriptProgressBar from "./transcriptProgressBar";
// const TranscriptProgressBar = lazy(() => import("./transcriptProgressBar"));

const AdmissionLetter = lazy(() => import("./letter"));

window.html2canvas = html2canvas;

const DashboardContext = createContext();

const ProgressSteps = {
  TranscriptRequestReceived: 1,
  StudentIdentityVerified: 2,
  AcademicRecordsCompiled: 3,
  TranscriptVerifedProofread: 4,
  NecessarySignaturesObtained: 5,
  InstitutionalSealApplied: 6,
  DigitalAndPrintedCopyPrepared: 7,
  TranscriptSent: 8,
  TranscriptDelivered: 9,
};

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      currentStep: 0,
      loader: true,
      pwdDialog: false,
      status: false,
      activeStep: 0,
      IsOlevelSaved: false,
      IsBiodataSaved: false,
      RegComplete: false,
      Admitted: false,
      warning: false,
      acceptance: 0,
      IsPasswdChgd: false,
      AdmissionStatus: false,
      IsDocUpload: false,
      admissionLetterDrawer: false,
      paymentDialog: false,
      remitaResponse: null,
      bioData: [],
      deptMent: [],
      programes: [],
      downloadDoc: [
        {
          fileExt: "",
          formId: 1,
          formUrl: "",
          levelIds: null,
          formName: "Provisional Admission Letter",
          departmentIds: null,
          formDescription: "View Letter showing Provisional Admission Details",
        },
      ],
      applicantData: [],
    };
  }

  async componentDidMount() {
    try {
      await this.loadContent();
    } catch (error) {
      NotificationManager.error("An error occurred during initialization.");
    }
  }

  departments = async (programId) => {
    try {
      const { matricNumber } = this.props;
      const response = await fetchJSON(
        `api/GetDepartmentByProgramTypeId?programId=${programId}`,
        null,
        "GET"
      );

      if (response) {
        this.setState({
          programes: response.Data,
          loader: false,
        });
      } else {
        NotificationManager.error("Failed to fetch progress data");
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error("Error fetching progress data:", error);
      this.setState({ loader: false });
      NotificationManager.error(
        "An error occurred while fetching progress data"
      );
    }
  };
  loadContent = async () => {
    try {
      const { matricNumber } = this.props;
      const response = await fetchJSON(
        `api/GetProgressSteps?matricNo=${matricNumber}`,
        null,
        "PUT"
      );
      const responseBioData = await fetchJSON(
        `api/GetBasicBiodataInfo?matricNo=${matricNumber}`,
        null,
        "GET"
      );
      const responsedept = await fetchJSON(`api/GetProgramTypes`, null, "GET");
      this.setState({
        currentStep: response,
        bioData: responseBioData?.Data,
        deptMent: responsedept?.Data,
        loader: false,
      });
      this.setState({ loader: false });
    } catch (error) {
      console.error("Error fetching progress data/info:", error);
      this.setState({ loader: false });
      NotificationManager.error(
        "An error occurred while fetching progress data"
      );
    }
  };

  render() {
    const { Provider } = DashboardContext;
    const { match, width, authUser, matricNumber } = this.props;
    const { loader, currentStep, bioData } = this.state;

    const steps = [
      "Request Received",
      "Identity Verified",
      "Records Compiled",
      "Verified & Proofread",
      "Signatures Obtained",
      "Seal Applied",
      "Copies Prepared",
      "Transcript Sent",
      "Delivered",
    ];

    return (
      <Provider>
        <div
          className="app-wrapper"
          style={{
            padding: "30px",
            backgroundColor: "#f1f1f1e6",
            backgroundImage:
              "url('data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e')",
          }}
        >
          <div className="dashboard animated slideInUpTiny animation-duration-3">
            <ContainerHeader
              match={match}
              title={<IntlMessages id="sidebar.dashboard" />}
            />
            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200
                        ? "calc(100vh - 265px)"
                        : "calc(100vh - 245px)",
                  }}
                >
                  <FaSpinner className="spin" />
                </div>
              }
            >
              <LoadingOverlay active={loader} spinner text="Checking...">
                <Row>
                  {/* <Col xs={12} sm={6} md={4} lg={2}>
                    <Card className="bg-primary text-white text-center">
                      <CardBody>
                        <h5>Last Session</h5>
                        <p>2024/2025</p>
                      </CardBody>
                    </Card>
                  </Col> */}
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Card className="bg-warning text-white text-center text-nowrap ">
                      <CardBody>
                        <h5>Program Type</h5>
                        <p>{bioData?.Program}</p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={3}>
                    <Card className="bg-danger text-white text-center">
                      <CardBody>
                        <h5>Matric Number</h5>
                        <p>{matricNumber}</p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={3}>
                    <Card className="bg-info text-white text-center">
                      <CardBody>
                        <h5>Program</h5>
                        <p>{bioData?.DepartmentName}</p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={3}>
                    <Card className="bg-dark text-white text-center">
                      <CardBody>
                        <h5>Email</h5>
                        <p>{bioData?.Email}</p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </LoadingOverlay>
            </Suspense>
          </div>
        </div>
        <TranscriptProgressBar
          steps={steps}
          currentStep={this.state.currentStep}
        />
        <NotificationContainer />
      </Provider>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  const matricNumber = auth.alumniUser?.MatricNo;
  return { authUser, userMode, matricNumber };
};

export default connect(mapStateToProps, { regStatus, userSignOut })(Dashboard);
export { DashboardContext };
